export default __webpack_public_path__ + "static/media/img-trans-run.c3e82638.gif";